import styled from 'react-emotion'
import { mobile, tablet, customDevice } from '../../../../../utils/mixins'

export const StatListContainer = styled('div')`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  padding-top: 30px;
  width: 40%;
  ${mobile} {
    font-size: 14px;
    padding-bottom: 0.5em;
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  ${tablet} {
    width: 100%;
    flex-wrap: nowrap;
    flex-direction: column;
  }
  ${customDevice(1024, 1160)} {
    width: 44%;
  }
`



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/IbCricketAtIpl2019/StatsSection/StatList/styledComponents.js